<template>
  <div id="dashboard">
    <v-container fluid class="pt-0">
      <v-container fluid class="pt-0">
        <v-layout row wrap>
          <v-flex md4>
            <v-text-field
            v-model="tableData.search"
            append-icon="search"
            @input="seaching"
            label="Search for previous submission..."
            single-line
            hide-details
          ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-layout row wrap>
        <v-flex md12>
          <v-progress-linear :indeterminate="processBar" height="2" class="my-0"></v-progress-linear>
          <v-data-table
            :headers="headers"
            :items="submissions"
            :hide-actions="true"
            v-bind:pagination.sync="pagination"
            class="pa-2"
            expand>
            <template v-slot:headers>
              <tr style="font-size:11px; background-color:#d3e6f5;">
                <td>Created</td>
                <td>Company Name</td>
                <td>DBA</td>
                <td>MID</td>
                <td>Status</td>
                <td>Offer Amount</td>
                <td>Factor Rate</td>
                <td>Commission</td>
                <td>Payment</td>
                <td>Last Updated</td>
                <!-- <td>ISO Reps</td> -->
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>{{ formatDate(props.item.created_at, 'MM/DD/YYYY hh:mm') }}</td>
                <td class="text-truncate" style="max-width:250px;">{{ props.item.company && props.item.company.company_name }}</td>
                <td class="text-truncate" style="max-width:250px;">{{ props.item.company && props.item.company.company_dba }}</td>
                <td class="text-truncate" style="max-width:250px;">{{ props.item.contract_MID }}</td>
                <td class="text-truncate" style="max-width:125px; text-align: center;">
                  <div :class="check_status(props.item.deal_status)">{{ props.item.deal_status }}</div>
                </td>
                <td>{{ props.item.deal_lenders_with_offer_sent.length>0 ? (props.item.deal_lenders_with_offer_sent[0].lender_offer_amount) : ''  | currency}}</td>
                <td>{{ props.item.deal_sell_rate }}</td>
                <td>{{ props.item.deal_lenders_with_offer_sent.length>0 ? props.item.deal_lenders_with_offer_sent[0].lender_commission_amt : ''  | currency}}</td>
                <td>{{ props.item.deal_lenders_with_offer_sent.length>0 ? props.item.deal_lenders_with_offer_sent[0].lender_payment : ''  | currency}}</td>
                <td>{{ formatDate(props.item.updated_at, 'MM/DD/YYYY hh:mm') }}</td>
                <!-- <td>{{ props.item.agent_name }}</td> -->
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card color="grey lighten-3" v-for="(items, index) in props.item.deal_lenders_with_offer_sent" :key="index">
                <table class="table table-striped pt-2" style="width: 100%;">
                  <tr>
                    <th class="expand-th">Offer Amount: {{items.lender_offer_amount | currency}}</th>
                    <th class="expand-th">Payback Amount: {{items.lender_payback_amount | currency}}</th>
                    <th class="expand-th">Payment: {{items.lender_payment | currency}}, {{items.lender_payment_type}}</th>
                    <th class="expand-th">Factor Rate: {{items.lender_factor_rate}}</th>
                  </tr>
                  <tr>
                    <th class="expand-th">Buy Rate: {{items.lender_buy_rate}}</th>
                    <th class="expand-th">Commission Percentage: {{items.lender_commission_percentage}}</th>
                    <th class="expand-th">Term(days): {{items.lender_term}}</th>
                    <th class="expand-th">Position: {{items.lender_position_number}}</th>
                  </tr>
                  <tr>
                    <th class="expand-th">Fee Split: {{props.item.fee_split_percent}}</th>
                    <th class="expand-th">Lender Name: {{items.lender!=null ? items.lender.lender_name : ''}}</th>
                    <th class="expand-th">Tier: {{items.tier}}</th>
                    <th class="expand-th"></th>
                  </tr>
                  <tr>
                    <th class="expand-th" colspan="2">Offer Status: {{items.lender_offer_status}}</th>
                  </tr>
                    

                  <tr>
                    <th class="notes-th" >
                      ISO Notification Message:
                      <span>{{items.offer_notify_note}}</span>
                    </th>
                  </tr>
                </table>
              </v-card>
            </template>
          </v-data-table>
          <template>
            <div class="text-center">
              <v-pagination
                v-model="page"
                :length="pages"
                circle
                @input="next"
                :total-visible="7"
              ></v-pagination>
            </div>
          </template>
          <!-- <v-btn :loading="btn_loader" @click="downloadExcelReport" color="success" flat>
            Download Report
            <i class="pl-2 far fa-file-excel-o" style="font-size:15px"></i>
          </v-btn> -->
        </v-flex>
      </v-layout>
      <!-- <PreviewDialog
        v-if="previewDialog"
        :previewDialog="previewDialog"
        :selectedDeal="selectedDeal"
        @closePreviewDialog="closePreviewDialog"
      /> -->
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import _ from 'lodash'
import axios from  'axios'
import {URL} from '../../env'

// import PreviewDialog from '../../Dashboard/Executive/PreviewDialog'

export default {
  // mixins: [UserHelper],
  components: {
    // PreviewDialog,
  },
  // props: {
  //   tableData: {
  //     type: Object,
  //     default: {}
  //   }
  // },
  data() {
    return {
      btn_loader: false,
      processBar: false,
      funded_status: false,
      pagination: { sortBy: "created_at", descending: true, rowsPerPage: -1 },
      page: 1,
      pages: 0,
      previewDialog: false,
      selectedDeal: null,
      submissions: [],
      tableData: {
        page: 1,
        length: 10,
        search: ""
      },
      headers: [
        {
          text: "Created",
          value: "created_at"
        },
        {
          text: "Company Name",
          value: "company_name"
        },
  
        {
          text: "DBA",
          value: "company_dba"
        },
        {
          text: "MID",
          value: "contract_MID"
        },
        {
          text: "Status",
          value: "deal_status"
        },
        {
          text: "Offer Amount",
          value: "lender_offer_amount"
        },
        {
          text: "Factor Rate",
          value: "deal_sell_rate"
        },
        {
          text: "Commission",
          value: "lender_commission_amt"
        },
        {
          text: "Payment",
          value: "lender_payment"
        },
        {
          text: "Last Updated",
          value: "updated_at"
        },
        // {
        //   text: "ISO Reps",
        //   value: "agent_name"
        // },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    user_id() {
      return localStorage.getItem("user_id");
    },
    iso_id() {
      return localStorage.getItem("iso_id");
    }
  },
  // computed: {
  //   ...mapGetters({
  //     submissions: "deals/custom_report_subs"
  //   })
  // },
  methods: {
    // ...mapActions({
    //   getCustomReportSubmissions: "deals/getCustomReportSubmissions"
    // }),
    
    async downloadExcelReport(){
      // this.btn_loader = true
      // await this.$store.dispatch('deals/downloadCustomReportSubmissions',
      //   Object.assign(this.tableData, { page: this.page, export_excel: 'DOWNLOAD'})
      // ).then(res=>{
      //   this.btn_loader = false
      // })
    },
    formatDate(date,type) {
      return moment(date).format(type);
    },
    // getPreviewDialog(item) {
    //   this.selectedDeal = item;
    //   this.previewDialog = true;
    // },
    redirectToSubPage({ unique_id, id }) {
      let route = this.$router.resolve({
        path: `submission/${unique_id}`,
        query: { companyId: id }
      });
      window.open(route.href, "_blank");
    },
    async seaching(){
      this.processBar = true
      await this.getSearchSubmission()
    },
    getSearchSubmission: _.debounce(function(e) {
      this.page = 1;
      this.getData();
    }, 3000),
    next(e) {
      this.page = e;
      this.getData();
    },
    getData() {
      this.processBar = true
      axios.get(`${URL}/api/submission/isoportal_subs`,{
        params: Object.assign(this.tableData, { page: this.page, export_excel: null, user_id: this.user_id, iso_id: this.iso_id })
      }
        )
        .then(res => {
          this.submissions = res.data.data
          this.processBar = false
          this.funded_status = this.tableData.status == "Funded" ? true : false;
          this.page = Math.ceil(res.data.to / this.tableData.length);
          this.pages = Math.ceil(res.data.total / this.tableData.length);
        }).catch(err=>{
          this.processBar = false
        });
    },
    closePreviewDialog() {
      this.previewDialog = false;
    },
    check_status(s) {
      if (s == "Offer Sent") {
        return "offer_sent";
      } else if (s == "requested_information_file_upload") {
        return "requested";
      } else if (s == "Declined" || s == "Double Decline Submission") {
        return "decline";
      } else if (s == 1) {
        return "double_sub";
      }
    }
  }
};
</script>

<style scoped>
.expand-th {
  width: 25%;
  height: 20px;
  text-align: left;
  vertical-align: top;
}
.notes-th {
  height: 20px;
  text-align: left;
  vertical-align: top;
}
</style>